import UserTable from 'components/management/tables/UserTable';
import React, { useEffect } from 'react';
import { EmailSignUpDto, UserInfoDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import UserDetail from 'components/management/UserDetail';
import { Row } from 'saladsoft-primitive';
import UserFilter from 'components/management/filters/UserFilter';
import styled from 'styled-components';
import { getUrlParam } from 'libs/helper/utils';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

const UserPage = observer(() => {
  const { uiStore, userFilterStore } = useStoreWrapper();
  const location = useLocation();

  // 일반회원 목록 조회
  const fetchUsers = () => {
    const searchKeyword = getUrlParam('searchKeyword');
    const page = getUrlParam('page');
    const size = getUrlParam('size');

    userFilterStore.getUsers({
      searchKeyword: searchKeyword || '',
      page: page ? parseInt(page) - 1 : 0,
      size: size ? parseInt(size) : 20,
    });
  };

  // 일반회원 정보 수정
  const handleEditBtnClick = (user: UserInfoDto) => {
    uiStore?.modal.show({
      title: (
        <Row gap={10}>
          <span>
            {user.profile?.lastName} {user.profile?.firstName}
          </span>
        </Row>
      ),
      style: { width: '100%', maxWidth: '1200px', height: '100%', maxHeight: '80vh' },
      children: <UserDetail user={user} onSave={fetchUsers} />,
    });
  };

  useEffect(() => {
    fetchUsers();
  }, [location.search]);

  return (
    <div>
      <UserFilter onClickAdd={() => {}} />
      <UserTable users={userFilterStore.users} onEditBtnClick={handleEditBtnClick} />
    </div>
  );
});

const EmptyText = styled.div`
  text-align: center;
  margin-top: 20px;
`;

export default UserPage;
